/* eslint-env browser */

'use strict';

const { h, Component } = require('phy');
const FetchHandler = require('../../deal/frontend/FetchHandler');
const ErrorSolid = require('@design-system/ui-icons/preact/ErrorSolid').default;
const CheckCircleSolid =
  require('@design-system/ui-icons/preact/CheckCircleSolid').default;

const { APPLIED, ERROR, QUALIFIED, NO_EVENT } = require('../constants');
const ApplyPromoCodeComponent = require('../components/apply_promo_code_component');
const NotificationComponent = require('./../components/notification_component');

class ApplyPromoCodeContainer extends Component {
  constructor(props) {
    super(props);
    this.handleApplyClick = this.handleApplyClick.bind(this);
    this.promoApplied = this.promoApplied.bind(this);
    this.promoAppliedError = this.promoAppliedError.bind(this);
    this.getNewProps = this.getNewProps.bind(this);

    const { promotionsObj, currentDealOptionUuid } = props;
    this.state = {
      promoApplied: null,
      currentPromo: promotionsObj[currentDealOptionUuid],
    };
  }

  promoAppliedError() {
    this.setState({
      errorMessage: this.props.promoApplyCodeErrorText,
      notificationKlass: '.error',
      promoApplied: ERROR,
    });
  }

  promoApplied(response) {
    // we can receive 200 response but promo might not be QUALIFIED
    // we should show an error in this case
    if (response.status.toUpperCase() === QUALIFIED) {
      this.setState({
        notificationKlass: '.success',
        promoApplied: APPLIED,
        successMessage: response.message,
      });
    } else {
      this.promoAppliedError();
    }
  }

  getPromoEvent(currentPromo) {
    const { event } = currentPromo;
    return event ? event.trim() : NO_EVENT;
  }

  handleApplyClick(e) {
    e.preventDefault();
    const { currentPromo } = this.state;
    const url = `/deals/promo_codes/associate?event_name=${this.getPromoEvent(
      currentPromo
    )}`;
    this.fetchHandler = new FetchHandler({
      url,
      errorHandlers: [this.promoAppliedError],
      successHandlers: [this.promoApplied],
    });
    this.fetchHandler.send();
  }

  /**
   * We want to show the promo banner even when the selected option doesn't have any promotions.
   * Thus, we will not setState when the selected option doesn't have promotions.
   */
  updateState(optionUuid) {
    const promoObj = this.props.promotionsObj[optionUuid];
    if (promoObj) {
      this.setState({ currentPromo: promoObj });
    }
  }

  componentDidMount() {
    // support all the event pipes until goods moves to new buy buy button

    const { DealEventPipe, BuyButtonEventPipe } = window;
    if (DealEventPipe && DealEventPipe.eventsHash.has('goodsOptionUpdate')) {
      DealEventPipe.on('goodsOptionUpdate', ({ uuid }) => {
        this.updateState(uuid);
      });
    }
    if (
      BuyButtonEventPipe &&
      BuyButtonEventPipe.eventsHash.has('option_updated')
    ) {
      BuyButtonEventPipe.on('option_updated', ({ optionUuid }) => {
        this.updateState(optionUuid);
      });
    }
  }

  getPromoCodeTag(currentPromo) {
    return `<span class='promo-v2-code'>${currentPromo.promocode}</span>`;
  }

  getNewProps() {
    let { I18n } = this.props;
    if (typeof document === 'object') {
      I18n = window.I18n;
    }
    const { currentPromo } = this.state;
    if (!currentPromo) {
      return null;
    }
    return {
      applyCodeText: this.props.applyCodeText,
      promoAdditionalMessage: I18n.t(
        'js.modules.promo_code_v2.promo_additional_message',
        {
          promoCodeTag: this.getPromoCodeTag(currentPromo),
          promoEndsAt: currentPromo.endsAt,
        }
      ),
      promoMessage: currentPromo.message,
    };
  }

  handleDefaultCase(newProps) {
    if (newProps) {
      return h(ApplyPromoCodeComponent, {
        ...newProps,
        handleApplyClick: this.handleApplyClick,
      });
    }
    return null;
  }

  render() {
    const newProps = this.getNewProps();
    switch (this.state.promoApplied) {
      case APPLIED: {
        return h(
          '.success-container',
          h(CheckCircleSolid),
          h(NotificationComponent, {
            ...this.props,
            bhw: 'ClickToApplyPromoCodeInfo',
            messageText: this.state.successMessage,
            notificationKlass: this.state.notificationKlass,
          })
        );
      }
      case ERROR: {
        return h(
          '.apply-code-error-wrapper',
          h(ApplyPromoCodeComponent, {
            ...newProps,
            handleApplyClick: this.handleApplyClick,
          }),
          h(
            '.error-container',
            h(ErrorSolid),
            h(NotificationComponent, {
              ...this.props,
              bhw: 'ClickToApplyPromoCodeError',
              messageText: this.state.errorMessage,
              notificationKlass: this.state.notificationKlass,
            })
          )
        );
      }
      default: {
        return this.handleDefaultCase(newProps);
      }
    }
  }
}

module.exports = ApplyPromoCodeContainer;
